module.exports = __webpack_public_path__ + "media/15.f4a4833c.mp3";